import React from "react";
import CommonPage from "@icarius-common/commonPage";
import CustomIconButton from "@icarius-common/abmComponents/customIconButton";
import { getLocalizedString } from "@icarius-localization/strings";
import { COLUMN_PATHS } from "@icarius-pages/modulesAndMenus/columnDef";
import MenuItemWithIcon from "@icarius-common/MenuItemWithIcon";
import MenuFormDialog from "./menuFormDialog";
import useMenus from "./useMenus";

const Menus = () => {

  const {
    isLoading,
    menus,
    resources,
    state,
    handlers,
  } = useMenus();

  const editButton = (gridRef) => (
    <CustomIconButton
      title={getLocalizedString("edit")}
      onClick={() => handlers.handleOpenUpdateForm(gridRef)}
      type={"edit"}
    />
  )

  const helpItems = resources?.map((resource, index) => {
    return (
      <MenuItemWithIcon key={index} value={resource.path} text={resource.name} type={"file"} />
    )
  })

  return (
    <CommonPage
      isLoading={isLoading}
      gridTitle={getLocalizedString("menus")}
      helpItems={helpItems}
      rowData={menus}
      menuItems={[editButton]}
      columnDefPage={COLUMN_PATHS.menus}
      hasExpand
      hasHelp
    >
      {
        state.formIsOpen &&
        <MenuFormDialog
          open={state.formIsOpen}
          data={state.selectedItem}
          isLoading={isLoading}
          submitCallback={handlers.handleUpdate}
          handleClose={handlers.handleCloseForm}
        />
      }
    </CommonPage>
  )
}

export default Menus;